import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { getHomepage, getTopArtist1, getTopMuseum, topSellItems } from "store/actions";
import Slider from "react-slick";
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";
import { Oval } from 'react-loader-spinner'
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M21 15L9 15M15.75 20.25L21 15L15.75 9.75"
          stroke="#111111"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle opacity="0.7" cx="15" cy="15" r="14.5" stroke="black" />
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M21 15L9 15M15.75 20.25L21 15L15.75 9.75"
          stroke="#111111"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle opacity="0.7" cx="15" cy="15" r="14.5" stroke="black" />
      </svg>
    </div>
  );
}

export default function Communitynew() {
  const settings = {
    dots: false,
    infinite: false,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1169,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { topArtist, loading } = useSelector((s) => s?.museums)
  const { topSellItemData} = useSelector((selector) => selector?.SellItems)
  const { topCollections } = useSelector((state) => state?.home);
  const { authToken } = useSelector((state) => state?.Login);
  const fetchUserId = (item_id) => {
    if (!authToken) {
      toastr.error("Please Login");
    } else {
      navigate(`/profile?id=${item_id}`);
    }
  };

  useEffect(() => {
    dispatch(getTopArtist1());
    dispatch(getHomepage());
    dispatch(getTopMuseum())
    dispatch(topSellItems())
  }, [dispatch]);
  return (
    <>
     {loading &&
      <div className='loaderBoxMiane'>
        <Oval
          height={80}
          width={80}
          color="#6C63FF"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
          ariaLabel='oval-loading'
          secondaryColor="#6C63FF"
          strokeWidth={2}
          strokeWidthSecondary={2}
        />
      </div>
    }
      <section className="Broswes-section pt-3">

        <div className="communityHeading">
          <h2>Top Seller</h2>
          {/* <Link className="viewText" to={""}>
              View All
            </Link> */} 
        </div>
        <Row>
          <Col lg={12}>
          {topArtist && topArtist.length > 0 ? (
            <>
            <Slider {...settings}>
            { topArtist.map((data, index)=>
             <Link className="text-decoration-none" to={`/view-profile/artist/${data?._id}`} state = {{data}}>
              <div className="artItemBoxNew bg-white">
                <div className="imgBox">
                  <img
                    className="img-fluid"
                    src={data?.profileImage?.link}
                    alt=""
                  />
                </div>
                <div className="contBox">
                  <div className="arthead">
                    <h2 className="productName">{data?.name+" "+data?.lastname} </h2>
                  </div>
                </div>
              </div>
              </Link>
              )}
              
            </Slider>
            </>
          ):(
            <>
            <div className="text-center d-grid justify-content-center dataNotFound py-5">
              <img src={"/images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
              <h3>No Data Available</h3>
            </div>
            </>
          )}
          
          </Col>
        </Row>
        <div className="communityHeading mt-5">
          <h2>Trending Digital Artworks</h2>
          {/* <Link className="viewText" to={""}>
              View All
            </Link> */}
        </div>
        <Row>
          <Col lg={12}>
          {topSellItemData && topSellItemData.length > 0 ? (<>
            <Slider {...settings}>
              { topSellItemData.map((item, index)=>
                <Link className="text-decoration-none" to={`/nftsale/${item?._id}`}>
              <div className="artItemBoxNew bg-white">
                <div className="imgBox">
                  <img
                    className="img-fluid"
                    src={item?.nft_id?.image_id?.image?.link}
                    alt=""
                  /> 
                  
                </div>
                <div className="contBox">
                  <div className="arthead">
                    <h2 className="productName"> {item?.nft_id?.name} </h2>
                  </div>
                </div>
              </div>
              </Link>)}
             
            </Slider>
          </>):(
            <>
            <div className="text-center d-grid justify-content-center dataNotFound py-5">
              <img src={"/images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
              <h3>No Data Available</h3>
            </div>
            </>
          )}
           
          </Col>

        </Row>
        {/* <div className="communityHeading mt-5">
          <h2>Trending Museum</h2>
          <Link className="viewText" to={"/museums"}>
            View All
          </Link>
        </div> */}
        {/* <Row>
            {topMuseums && topMuseums.map((item, index)=>
            <Col lg={4}>
              <Link className="text-decoration-none" to={"/"}>
                <div className="topMeuseumMainBox bg-white">
                  <div className="imgBox">
                    <div className="imginn">
                      <img
                        className="img-fluid"
                        src={item?.bannerImage?.link ||"images/newpng/museumphoto.png"}
                        alt=""
                      />
                    </div>
                    <div className="meusimphoto">
                      <img
                        className="img-fluid"
                        src={item?.profileImage?.link}
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="contBox">
                    <div className="arthead justify-content-center mb-2">
                      <h2 className="productName">{item?.museumName}</h2>
                    </div>
                    <p>{item?.description}</p>
                  </div>
                  <div className="position-relative">
                    <div className="bottomOPtions">
                      {/* {
                         item?.collection.map((item, index)=>{})
                      } */}
        {/* <ul>
                        <li>
                          <p>Items</p>
                          <h3>--</h3>
                        </li>
                        <li>
                          <p>Views</p>
                          <h3>--</h3>
                        </li>
                        <li>
                          <p>Floor Price</p>
                          <h3>$ --</h3>
                        </li>
                        <li>
                          <p>7D Volume</p>
                          <h3>$ --</h3>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> */}
        {/* </Link>
            </Col>)} */}
        {/* <Col lg={4}>
              <Link className="text-decoration-none" to={"/"}>
                <div className="topMeuseumMainBox bg-white">
                  <div className="imgBox">
                    <div className="imginn">
                      <img
                        className="img-fluid"
                        src={"images/newpng/commingsoon.png"}
                        alt=""
                      />
                    </div>
                    <div className="meusimphoto">
                      <img
                        className="img-fluid"
                        src={"images/newpng/museumphoto.png"}
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="contBox">
                    <div className="arthead justify-content-center mb-2">
                      <h2 className="productName">Museum Name</h2>
                    </div>
                    <p>Museum Description </p>
                  </div>
                  <div className="position-relative">
                    <div className="bottomOPtions">
                      <ul>
                        <li>
                          <p>Items</p>
                          <h3>--</h3>
                        </li>
                        <li>
                          <p>Views</p>
                          <h3>--</h3>
                        </li>
                        <li>
                          <p>Floor Price</p>
                          <h3>$ --</h3>
                        </li>
                        <li>
                          <p>7D Volume</p>
                          <h3>$ --</h3>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Link>
            </Col>
            <Col lg={4}>
              <Link className="text-decoration-none" to={"/"}>
                <div className="topMeuseumMainBox bg-white">
                  <div className="imgBox">
                    <div className="imginn">
                      <img
                        className="img-fluid"
                        src={"images/newpng/commingsoon.png"}
                        alt=""
                      />
                    </div>
                    <div className="meusimphoto">
                      <img
                        className="img-fluid"
                        src={"images/newpng/museumphoto.png"}
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="contBox">
                    <div className="arthead justify-content-center mb-2">
                      <h2 className="productName">Museum Name</h2>
                    </div>
                    <p>Museum Description </p>
                  </div>
                  <div className="position-relative">
                    <div className="bottomOPtions">
                      <ul>
                        <li>
                          <p>Items</p>
                          <h3>--</h3>
                        </li>
                        <li>
                          <p>Views</p>
                          <h3>--</h3>
                        </li>
                        <li>
                          <p>Floor Price</p>
                          <h3>$ --</h3>
                        </li>
                        <li>
                          <p>7D Volume</p>
                          <h3>$ --</h3>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Link>
            </Col> */}
        {/* </Row> */}
        <div className="currenta-auction-slider " hidden>
          <Slider {...settings}>
            {topArtist?.length > 0 &&
              topArtist.map((item, idx) => {

                return (
                  <div key={idx}>
                    <div className="digital-art-wrap upcomimg-aution">
                      <div
                        onClick={() => fetchUserId(item?.user_details?._id)}
                        className="currentlive-art-img position-relative"
                      >
                        <img
                          src={
                            item?.profileImage?.link || "images/avatar.png"
                          }
                          alt=""
                          className="img-fluid home-cate"
                        />
                      </div>
                      <div className="upcomimg-art-content">
                        <div className="user-partwrap">
                          <div className="user-part">
                            <h3>{item?.user_details?.name}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </Slider>
        </div>

      </section>

      <section className="community_new" hidden>
        <Container>
          <div className="DigitalArtcollection-head currentauction-head">
            <h2>Top Collections</h2>
          </div>

          {topCollections?.length > 0 ? (
            <Row>
              {topCollections?.map((topCol, idx) => {
                return (
                  <Col lg={4} md={6} sm={12}>
                    <Link
                      to={`/card-profile?id=${topCol?.contractAddress}`}
                      className="link_collection"
                    >
                      <div className="card-top-collection">
                        <span>{idx + 1}</span>
                        <div className="img_here  ">
                          <img
                            src={
                              topCol?.image?.link || "/images/owner-user.png"
                            }
                            alt=""
                          />
                        </div>
                        <div className="content_here">
                          <h5>{topCol?.name}</h5>
                          <p>Floor : {topCol?.floorPrice || 0} </p>
                        </div>
                      </div>
                    </Link>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <div className="mt-5 w-100">
              <h5 className="collect-head">No Top Collection Found !!</h5>
            </div>
          )}
        </Container>
      </section>
    </>
  );
}
